/**
 * Entry point.
 *
 * Provider order matters: the toaster is outermost so anything can raise one,
 * the router next, and the auth provider inside it so guards can use both the
 * session and `useLocation`.
 *
 * `StrictMode` is on. It double-invokes effects in development, which is why
 * the refresh call is single-flight — a replayed refresh token is treated as
 * theft by the API and would revoke the whole session family.
 */
import { ToastProvider } from '@wend/ui';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import './index.css';

const container = document.getElementById('root');

if (container === null) {
  throw new Error('#root is missing from index.html — the app has nowhere to mount.');
}

createRoot(container).render(
  <StrictMode>
    <ToastProvider>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ToastProvider>
  </StrictMode>,
);
